<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'CREATE_REMINDER'"
    (closing)="closeDialog(); createReminderForm.reset()"
    [form]="createReminderForm.form"
    header="employees.onboardingSettings.addReminder"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="onCreateOnboardingReminder(createReminderForm)"
>
    <app-form-onboarding-reminder #createReminderForm></app-form-onboarding-reminder>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'EDIT_REMINDER'"
    (closing)="closeDialog(); editReminderForm.reset()"
    [form]="editReminderForm.form"
    header="employees.onboardingSettings.editReminder"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="editReminder(editReminderForm)"
>
    <app-form-onboarding-reminder #editReminderForm></app-form-onboarding-reminder>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'CREATE_QUESTION'"
    (closing)="closeDialog(); createQuestionForm.reset()"
    [form]="createQuestionForm.form"
    header="employees.onboardingSettings.addQuestion"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="onCreateOnboardingQuestion(createQuestionForm)"
>
    <ui-banner variant="warning" class="margin-bottom-3 text-color-warning align-left">
        <p>
            <b>{{ 'employees.onboardingSettings.questionsWillBeSent' | translate }}</b
            ><br />
            {{ 'employees.onboardingSettings.avoidSensitiveInformation' | translate }}
        </p>
    </ui-banner>
    <app-form-onboarding-question #createQuestionForm></app-form-onboarding-question>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'EDIT_QUESTION'"
    (closing)="closeDialog(); editQuestionForm.reset()"
    [form]="editQuestionForm.form"
    header="employees.onboardingSettings.editQuestion"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="editQuestion(editQuestionForm)"
>
    <app-form-onboarding-question #editQuestionForm></app-form-onboarding-question>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'DEFAULT_WELCOME_MESSAGE'"
    (closing)="closeDialog(); defaultWelcomeMessageForm.reset()"
    [form]="defaultWelcomeMessageForm.form"
    header="employees.onboardingSettings.editDefaultWelcomeMessage"
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    (primaryButtonPressed)="saveDefaultWelcomeMessage(defaultWelcomeMessageForm)"
>
    <app-form-employees-default-welcome-message
        #defaultWelcomeMessageForm
        [defaultWelcomeMessage]="options?.defaultWelcomeMessage"
    >
    </app-form-employees-default-welcome-message>
</ui-dialog>

<ui-confirmation-dialog
    #confirmationDialog
    primaryButtonLabel="delete"
    primaryButtonType="danger"
></ui-confirmation-dialog>

<ui-dialog
    class="default-video-dialog"
    [open]="currentlyOpenDialog === 'DEFAULT_VIDEO'"
    (closing)="videoLookup?.reset(); closeDialog()"
    header="{{ 'employees.onboardingSettings.editDefaultOnboardingVideo' | translate }}"
    [form]="videoLookup?.form"
>
    <div class="font-secondary margin-bottom-5">
        {{ 'employees.onboardingSettings.thisVideoWillBeShown' | translate }}
    </div>
    @if (currentlyOpenDialog === 'DEFAULT_VIDEO') {
        <app-video-lookup #videoLookup [videoMetadata]="onboardingVideoMetadata" />
    }
    @if (!videoLookup?.isLoading) {
        <ui-dialog-footer class="margin-top-5">
            @if (videoLookup?.videoMetadata) {
                <ui-button (click)="videoLookup?.reset()" class="margin-right-auto" type="danger-ghost">{{
                    'videos.removeVideo' | translate
                }}</ui-button>
            }
            <ui-button (click)="videoLookup?.reset(); closeDialog()" type="ghost">{{ 'cancel' | translate }}</ui-button>
            <ui-button (click)="saveDefaultVideo(videoLookup)" type="primary">{{ 'save' | translate }}</ui-button>
        </ui-dialog-footer>
    }
</ui-dialog>

<!-- Body -->

<div class="page-container" [class.loading]="isLoading">
    <app-header
        title="{{ 'employees.onboardingSettings.people' | translate }}"
        [menuService]="employeeModuleMenuService"
    >
        <div class="buttons">
            <ui-button type="primary" (click)="currentlyOpenDialog = 'CREATE_REMINDER'">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.onboardingSettings.onboardingReminder' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div class="profile-layout reverse">
        <div class="profile-layout-content">
            <ui-card *ngIf="options">
                <div>
                    <app-segment-header
                        title="{{ 'employees.onboardingSettings.collectEmployeeBankingInfo' | translate }}"
                        class="margin-bottom-4"
                        (edit)="editBankingInfo()"
                    ></app-segment-header>
                    <div class="responsive-grid">
                        <div class="row">
                            <div>{{ 'employees.onboardingSettings.bankingInfoRequiredForAll' | translate }}</div>
                            <div>{{ (settings.bankingInformationRequired?.value ? 'yes' : 'no') | translate }}</div>
                        </div>
                    </div>
                </div>
            </ui-card>

            <ui-card>
                <app-segment-header
                    title="{{ 'employees.onboardingSettings.defaultWelcomeMessage' | translate }}"
                    class="margin-bottom-1"
                    (edit)="currentlyOpenDialog = 'DEFAULT_WELCOME_MESSAGE'"
                ></app-segment-header>
                <span
                    [innerHTML]="
                        'employees.onboardingSettings.defaultWelcomeMessageHelp'
                            | translate
                                : {
                                      supportLink: ('4409790808727' | i18nHelpCentre),
                                  }
                            | sanitizeHtml
                    "
                ></span>
                <div
                    *ngIf="options?.defaultWelcomeMessage; else noMessageBlock"
                    [innerHTML]="options?.defaultWelcomeMessage | sanitizeHtml"
                    class="defaultWelcomeMessagePreview"
                ></div>
                <ng-template #noMessageBlock>
                    <div class="no-content">
                        {{ 'employees.onboardingSettings.noDefaultWelcomeMessageSet' | translate }}
                    </div>
                </ng-template>
            </ui-card>

            @if (onboardingVideoEnabled) {
                <ui-card [class.loading]="videoPreview?.isLoading">
                    <app-segment-header
                        title="{{ 'employees.onboardingSettings.defaultOnboardingVideo' | translate }}"
                        (edit)="openDefaultVideoModal()"
                    ></app-segment-header>
                    {{ 'employees.onboardingSettings.thisVideoWillBeShown' | translate }}
                    @if (options?.defaultOnboardingVideo?.url; as videoUrl) {
                        <app-video-preview
                            class="margin-top-2"
                            [videoUrl]="videoUrl"
                            (onVideoLoad)="onboardingVideoMetadata = $event"
                        ></app-video-preview>
                    } @else {
                        <div class="no-content">
                            {{ 'employees.onboardingSettings.noDefaultOnboardingVideoSet' | translate }}
                        </div>
                    }
                </ui-card>
            }

            <ui-card>
                <!-- Onboarding Reminder Content -->
                <app-segment-header
                    title="{{ 'employees.onboardingSettings.onboardingReminders' | translate }}"
                ></app-segment-header>

                <app-table
                    [table]="table"
                    (menuItemSelected)="menuAction($event)"
                    [useStickyHeader]="false"
                    [embedded]="true"
                    [showOffset]="false"
                    [noPadding]="true"
                    [showActionsPadding]="false"
                >
                    <app-empty-state label="employees.onboardingSettings.noOnboardingRemindersFound"></app-empty-state>
                </app-table>
            </ui-card>

            <ui-card class="new-hire">
                <app-segment-header title="{{ 'employees.onboardingSettings.newHireQuestions' | translate }}">
                    <div class="buttons">
                        <ui-button type="link" (click)="currentlyOpenDialog = 'CREATE_QUESTION'"
                            ><mat-icon svgIcon="plus"></mat-icon
                            >{{ 'employees.onboardingSettings.addQuestion' | translate }}</ui-button
                        >
                    </div>
                </app-segment-header>

                <ui-banner variant="info" class="margin-bottom-3">
                    <p>
                        <b>{{ 'employees.onboardingSettings.questionsWillBeSent' | translate }}</b
                        ><br />
                        {{ 'employees.onboardingSettings.avoidSensitiveInformation' | translate }}
                    </p>
                </ui-banner>
                <app-table
                    [table]="newHireQuestionTable"
                    [useStickyHeader]="false"
                    [showOffset]="false"
                    [embedded]="true"
                    (menuItemSelected)="newHireQuestionMenuAction($event)"
                    [noPadding]="true"
                    [showActionsPadding]="false"
                >
                    <app-empty-state label="employees.onboardingSettings.noNewHireQuestions"></app-empty-state>
                </app-table>
            </ui-card>
        </div>
        <div class="profile-layout-sidebar">
            <ui-card>
                <app-segment-header
                    title="{{ 'employees.onboardingSettings.sendInvites' | translate }}"
                ></app-segment-header>
                <p>{{ 'employees.onboardingSettings.sendInvitesToAllOnboardingEmployees' | translate }}</p>
                <ui-button (click)="sendAccountInvites()" type="primary">{{
                    'employees.onboardingSettings.send' | translate
                }}</ui-button>
            </ui-card>
        </div>
    </div>
</div>
